import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { AzureHealthCard } from './AzureHealthCard';

export const azureModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [AzureHealthCard],
});
